import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getDieCutters({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_DIE_CUTTERS_REQUEST')

        return axios
            .get(`/die-cutters/die-cutters${paginate}${query}`)
            .then(response => {
                commit('GET_DIE_CUTTERS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DIE_CUTTERS_FAILURE')
                handleApiError(error, 'Pobranie wykrojników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationDieCutters({ commit }) {
        commit('GET_DIE_CUTTERS_REQUEST')

        return axios
            .get('/calculations/calculations/die-cutters')
            .then(response => {
                commit('GET_DIE_CUTTERS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DIE_CUTTERS_FAILURE')
                handleApiError(error, 'Pobranie wykrojników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDieCuttersOwnershipTypes({ commit }) {
        return axios
            .get('/die-cutters/die-cutters/dicts/ownership-types')
            .then(response => {
                commit('GET_DIE_CUTTERS_OWNERSHIP_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów własności wykrojników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDieCutter(context, id) {
        return axios
            .get(`/die-cutters/die-cutters/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o wykrojniku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createDieCutter({ commit }, payload) {
        return axios
            .post('/die-cutters/die-cutters', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wykrojnik został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie wykrojnika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateDieCutter({ commit }, payload) {
        return axios
            .put(`/die-cutters/die-cutters/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wykrojnik został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja wykrojnika nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteDieCutter({ commit }, dieCutterId) {
        return axios
            .delete(`/die-cutters/die-cutters/${dieCutterId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wykrojnik został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie wykrojnika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getLocalizationRacks(context, localizationType) {
        return axios
            .get(`/localization/localization-racks/${localizationType.localizationTypeId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie regałów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getLocalizationShelves(context, payload = {
        hallId: null,
        localizationTypeId: null,
        rack: null
    }) {
        const hallId = payload.hallId,
            localizationTypeId = payload.localizationTypeId,
            rack = payload.rack

        return axios
            .get(`/localization/localization-shelves/${hallId}/${localizationTypeId}/${rack}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie półek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addDieCutterFileAttachment({ commit, state }, { formData, abort}) {
        if (!abort) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', cancelTokenSource)
        } else {
            state.cancelToken.cancel('Canceled')
        }

        commit('FILE_PROGRESS', {
            show: true,
            value: 0
        }, { root: true })

        return axios
            .post('/die-cutters/die-cutters/file/upload', formData, {
                cancelToken: state.cancelToken.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: false,
                        value: percentCompleted
                    }, { root: true })
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie pliku nie powiodło się.')

                return Promise.reject(error)
            })
            .finally(() => {
                commit('SET_CANCEL_TOKEN', null)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0
                }, { root: true })
            })
    },
    deleteDieCutterFileAttachment(context, id) {
        return axios
            .delete(`/die-cutters/die-cutters/file/upload/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie pliku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setDieCuttersFilters({ commit }, filters) {
        commit('SET_DIE_CUTTERS_FILTERS', filters)
    },
    clearDieCuttersFilters({ commit }) {
        commit('CLEAR_DIE_CUTTERS_FILTERS')
    }
}